// Theme
export default {
  primaryColor: '#80A0F1',
  successColor: '#80D2D1',
  warningColor: '#EBB248',
  dangerColor: '#F56C6C',
  infoColor: '#909399'
}



// WEBPACK FOOTER //
// ./src/style/theme.js